<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton'] ">
    <user-info-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></user-info-form>
  </j-modal>
</template>

<script>

  import UserInfoForm from './UserInfoForm'
  export default {
    name: 'UserInfoModal',
    components: {
      UserInfoForm
    },
    data () {
      return {
        title:'',
        width:1200,
        visible: false,
        disableSubmit: true
      }
    },
    computed: {
      language() {
            return this.$store.getters.language
          }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      detail (record) {
        this.visible=true
        this.disableSubmit=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        //this.$refs.realForm.submitForm();
        this.$refs.realForm.handleSubmit();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      show(){
          this.visible = true;
      },
    }
  }
</script>